import React from 'react';
import PropTypes from 'prop-types';
import t from '@instructure/quiz-i18n/es/format-message';
import { Text } from '@instructure/ui-text';
import { Button } from '@instructure/ui-buttons';
export var ExportButton = function ExportButton(_ref) {
  var enabled = _ref.enabled,
    handleExport = _ref.handleExport;
  return /*#__PURE__*/React.createElement(Button, {
    color: enabled ? 'secondary' : 'primary-inverse',
    interaction: enabled ? 'enabled' : 'disabled',
    onClick: handleExport,
    themeOverride: {
      lineHeight: '24px'
    },
    "data-automation": "sdk-new-report-export-button"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "medium"
  }, t('Export CSV')));
};
ExportButton.propTypes = {
  enabled: PropTypes.bool.isRequired,
  handleExport: PropTypes.func.isRequired
};